// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  getCustomerTaskTable ({commit, state}, params) {
    let promised = request.alert('getCustomerTaskTable', params)
    return promised
  },
}

// mutations
const mutations = {}

export const customerTask = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/customer-task/customer-task.store.js